// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"c0404962","71":"21fa315f","88":"3821922f","436":"82738386","618":"e15562a4","623":"734b3511","918":"ed0995ac"}[chunkId] + ".css";
};